export const transitionDuration = '0.3s'
